import { Fragment, type ReactNode } from "react";

const SLOT_SPLIT = /(\{\w+\})/;
const SLOT_NAME = /^\{(\w+)\}$/;

export function fillSlots(
  text: string,
  slots: Record<string, ReactNode>,
): ReactNode[] {
  return text.split(SLOT_SPLIT).map((part, index) => {
    const name = SLOT_NAME.exec(part)?.[1];
    if (name && name in slots) {
      return <Fragment key={index}>{slots[name]}</Fragment>;
    }
    return part;
  });
}
